import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for this plugin
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Requests the currently open report be generated, in the background.
     * The file becomes downloadable from the processes slideout once
     * generation finishes — this only tracks whether the request itself was
     * accepted
     */
    download: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        cancellation: ({ state }): State => ({
          ...state,
          isDownloading: false,
        }),
        error: ({ state }): State => ({ ...state, isDownloading: false }),
        request: ({ state }): State => ({ ...state, isDownloading: true }),
        success: ({ state }): State => ({ ...state, isDownloading: false }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
